export default "https://cdn-static.gokick.com/assets/30adf10d1d1967cb40501bfdbefb418f6cea25a6/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";